import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { renderSections } from "@/components/sections";
import { usePageSections } from "@/hooks/usePageSections";
import { LANDING_BUILTINS as BUILTINS } from "@/lib/builtinSections";

export default function LandingPage() {
  const sections = usePageSections("landing", Object.keys(BUILTINS));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-slate-950 text-slate-200 min-h-screen" data-testid="landing-page">
      <Header />
      <main>
        {sections ? (
          renderSections(sections, BUILTINS)
        ) : (
          <div className="flex min-h-screen items-center justify-center" data-testid="landing-loading">
            <Loader2 className="h-6 w-6 animate-spin text-sky-400" />
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
